<template>
  <div>
    <sys-data-table
      v-model="selecionados"
      :headers="headers"
      :items="desserts"
      :search="pesquisar"
      :fixed-header="true"
      :height="alturaDaJanela - 170"
      :item-height="35"
      :loading="loading"
      item-key="idproduto"
      show-select
    >
      <template #top>
        <v-spacer />

        <v-text-field
          v-model="pesquisar"
          append-icon="mdi-magnify"
          label="Pesquisa"
          dense
          clearable
          outlined
          hide-details
          class="my-2"
          style="max-width: 450px;"
        />

        <NovoSubMenu
          @atualizar-tela-inicial-menu-configuracao-sub-menu="atualizarSubMenus()"
        />
      </template>

      <template #item.editar="{ item }">
        <EditarSubMenu
          v-model="item"
          @atualizar-tela-inicial-menu-configuracao-sub-menu="atualizarSubMenus()"
        />
      </template>

      <template #item.deletar="{ item }">
        <DeletarSubMenu
          v-model="item"
          @atualizar-tela-inicial-menu-configuracao-sub-menu="atualizarSubMenus()"
        />
      </template>

      <template #item.icone="{ item }">
        <v-icon>{{ item.icone }}</v-icon>
      </template>
    </sys-data-table>
  </div>
</template>

<script>
import NovoSubMenu from './Dialog/NovoSubMenu.vue';
import EditarSubMenu from './Dialog/EditarSubMenu.vue';
import DeletarSubMenu from './Dialog/DeletarSubMenu.vue';

import Responsividade from '@/helpers/ResponsiveHeight';
import { buscarSubMenusConfiguracaoMenuParametrizacao } from '../Api';
export default {
  components: {
    NovoSubMenu,
    EditarSubMenu,
    DeletarSubMenu
  },
  mixins: [Responsividade],
  data: () => ({
    headers: [
      { text: 'ID', value: 'id', style: { width: '50px' }},
      { text: 'Menu', value: 'descricao_menu' },
      { text: 'Sub Menu', value: 'descricao' },
      { text: 'Url', value: 'url' },
      { text: '', value: 'editar', style: { width: '35px' }},
      { text: '', value: 'deletar', style: { width: '35px' }},
    ],
    desserts: [],
    pesquisar: '',
    selecionados: [],
    loading: false
  }),
  mounted() {
    this.buscarSubMenus();
  },
  methods: {
    buscarSubMenus() {
      this.$store.dispatch(
        'loading/addRequisicao',
        buscarSubMenusConfiguracaoMenuParametrizacao()
          .then((sub_menus) => this.desserts = sub_menus)
          .catch(() => this.Helpers.logout())
          .finally(() => this.loading = false)
      )
    },
    atualizarSubMenus() {
      this.desserts = [];
      this.loading = true;
      this.buscarSubMenus();
    }
  }
}
</script>

<style>

</style>
